import { DOCS_LINK } from "@/constants";
import { FeatureFlags } from "@/constants/featureFlags";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useLocation } from "wouter";
import { DOCS_PATH_MAPPINGS } from "./docsLinkMapping";

const normalizePath = (pathname: string): string => {
  if (pathname.startsWith("/explorer/id/") || pathname.startsWith("/explorer/staking/")) {
    return pathname.replace("/explorer", "");
  }

  if (pathname.startsWith("/cloud/id/")) {
    return pathname.replace("/cloud", "");
  }

  return pathname;
};

const matchesPathPrefix = (pathname: string, pathPrefix: string) => {
  return pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`);
};

export const useDocsLink = () => {
  const [location] = useLocation();
  const variant = useFeatureFlag(FeatureFlags.MAP_DOCS_TO_PRODUCTS);
  const isDocsMappingEnabled = Boolean(variant && variant.value !== "control");
  const locationPathname = location.split("?")[0] || "/";
  const pathname = normalizePath(locationPathname);

  if (!isDocsMappingEnabled) {
    return { docsLink: DOCS_LINK, isDocsMappingEnabled, pathname };
  }

  const mapping = DOCS_PATH_MAPPINGS.find(({ pathPrefix }) =>
    matchesPathPrefix(pathname, pathPrefix)
  );

  return {
    docsLink: mapping?.docsLink ? `${DOCS_LINK}${mapping.docsLink}` : DOCS_LINK,
    isDocsMappingEnabled,
    pathname
  };
};
